import { Card as CardRainbow } from 'react-rainbow-components';
import styled from 'styled-components';

export const Card = styled(CardRainbow)`
  padding: 2px 4px;
  border: none;
  border-radius: 8px;
  box-shadow: 0 0px 4px 0 #d7d9e2;
`;
